<template>
    <div class="display-4 text-center">
        <h1>{{titulo}}</h1>

    </div>
</template>

<script>
    export default {
        name: 'Header',
        props: {
            titulo: String
        }
    };
</script>

<style scoped>
</style>